module.exports = __webpack_public_path__ + "static/media/19ESCAP36.9a338508.jpg";